import { Component, Mixins } from 'vue-property-decorator'
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, ChartData, ChartOptions, ArcElement, Tooltip, Legend } from 'chart.js'
import WidgetMixin from '../../mixins/WidgetMixin'
import { TooltipItem } from 'chart.js/dist/types'

ChartJS.register(ArcElement, Tooltip, Legend)

@Component({
  components: {
    Pie
  }
})
export default class WidgetDiagram extends Mixins(WidgetMixin) {
  get chartData (): ChartData {
    const datas = this.dashboardData as KwixeoDashboard.BarDatas
    const datasets = [
      {
        data: datas.map(data => data[(this.value.params as KwixeoDashboard.BarParams).value]),
        backgroundColor: this.dataColors
      }
    ]

    if (this.computedCompare) {
      const datasCompare = this.dashboardDataCompare as KwixeoDashboard.BarDatas
      datasets.push({
        data: datasCompare.map(data => data[(this.value.params as KwixeoDashboard.BarParams).value]),
        backgroundColor: this.dataColors
      })
    }

    return {
      labels: this.labels,
      datasets
    }
  }

  get chartOptions (): ChartOptions {
    return {
      elements: {
        arc: {
          borderWidth: 1
        }
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 10,
          bottom: 5
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom'
        },
        tooltip: {
          mode : 'index',
          boxPadding: 5,
          callbacks: {
            label: (tooltipItem: TooltipItem<'pie'>): string | string[] | void => {
              let compareValue: number|null = null
              if (this.computedCompare && tooltipItem.datasetIndex === 0) {
                compareValue = tooltipItem.chart.data.datasets[tooltipItem.datasetIndex+1].data[tooltipItem.dataIndex] as number
              }
              return this.tooltipLabel(tooltipItem.parsed, tooltipItem.chart.data.datasets[0].data as number[], compareValue)
            }
          }
        }
      }
    }
  }
}
